import { useEffect, useMemo, useState } from "react";

import {
  matchesShopifyCartLines,
  subscribeShopifyLiveCommerceCart,
  toShopifyCartLineInputs,
} from "./syncCart";

import type { ShopifyLiveCommerceCart } from "./syncCart";

/**
 * 画面のカートと一致した Shopify カートの checkoutUrl。
 *
 * popup はクリックの中で開く必要があるので、同期が済んで内容が一致するまでは
 * undefined を返し、購入ボタンを押せないようにする。
 */
export const useShopifyCheckoutUrl = (
  eventId: string | undefined,
  items: { _id?: string; count: number }[]
): string | undefined => {
  const [shopifyCart, setShopifyCart] = useState<
    ShopifyLiveCommerceCart | undefined
  >(undefined);

  useEffect(() => {
    // イベントが切り替わったとき、前のイベントのカートを引きずらない
    setShopifyCart(undefined);
    if (eventId === undefined) return;
    return subscribeShopifyLiveCommerceCart(eventId, setShopifyCart);
  }, [eventId]);

  return useMemo(() => {
    if (shopifyCart === undefined) return undefined;
    const lines = toShopifyCartLineInputs(items);
    if (!matchesShopifyCartLines(shopifyCart, lines)) return undefined;
    return shopifyCart.checkoutUrl;
  }, [shopifyCart, items]);
};
